import { useState } from "react";

import "./stylesUserDeletionModal.css";

import BlockUserIcon from "../../../assets/icons/ic_block-user.svg";

import { CloseOutlined } from "@ant-design/icons";
import { API_ROUTES } from "../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { message } from "antd";

function UserDeletionModal({ handleCancel, adminId, setData, data }) {
  const token = JSON.parse(localStorage.getItem("token"));

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [messageApi, contextHolder] = message.useMessage();

  const onCancel = () => {
    handleCancel();
  };

  const onDelete = async () => {
    const params = {
      admin_id: adminId,
    };

    try {
      await PrivateAdminPanelInstance?.post(API_ROUTES?.DELETE_ADMIN, params);

      messageApi.success("Agent deleted successfully.");
      
      setData(data.filter((item) => item.admin_id !== adminId));
    } catch (error) {
      console.log("error creating admin", error?.resposne);
    } finally {
      handleCancel();
    }
  };

  return (
    <div className="user-deletion-modal-container">
      {contextHolder}
      <div className="modal-header">
        <div className="modal-header-title">
          <img src={BlockUserIcon} alt="Block User" />
          <h2 className="modal-title">Agent Deletion</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <p className="modal-content-title">
          Do you really want to delete this account?
        </p>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={onCancel}>
            No
          </button>
          <button className="save-button" onClick={() => onDelete(adminId)}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserDeletionModal;
